export default __webpack_public_path__ + "60bfd59c8b7e91710f4d42774ff87a72.svg";